import { render, staticRenderFns } from "./metrics_writing_breakdown.vue?vue&type=template&id=0542b2e8&scoped=true&"
import script from "./metrics_writing_breakdown.vue?vue&type=script&lang=js&"
export * from "./metrics_writing_breakdown.vue?vue&type=script&lang=js&"
import style0 from "./metrics_writing_breakdown.vue?vue&type=style&index=0&id=0542b2e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0542b2e8",
  null
  
)

export default component.exports